import { IParticipant } from "bets.oddprovider.lib.common.ts/models"
import { NumberUtils } from "fwork-jsts-common/src"
import { ApiClientUtils } from "fwork-jsts-common/src/apiClient"
import { FilterQuery } from "mongoose"
import { useSnackbar } from "notistack"
import * as React from 'react'
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { DEFAULTGAP, RoutesNames } from "../../globals"
import { toggleLoading } from "../../redux/reducers/loadingBar.slice"
import { IParticipantsState, participantsStateLoadFromApi } from "../../redux/reducers/participants.slice"
import { RootState } from "../../redux/store"
import { HeaderComponent } from "../common/header"
import { SearchInputComponent } from "../common/searchInput"
// import { TableComponent } from '../common/table'
// import { StyledListItemText, StyledTableCell, TableComponentClickRowProps, TableComponentSetCurrPageProps } from '../common/table/common'
import { StyledListItemText, StyledTableCell, TableComponent, TableComponentSetCurrPageProps } from 'fwork.react.apptemplate'
import { ParticipantImgComponent } from "./participantImg"

export const ParticipantsComponent = (props: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>) => {
  const tableComponentSetCurrPageRef = React.useRef<TableComponentSetCurrPageProps>(() => { });
  const tableComponentSetCurrPage = tableComponentSetCurrPageRef.current

  const participantsState: IParticipantsState = useSelector((state: RootState) => state.participantsState)
  const participants = [...participantsState.payload || []]
  const navigate = useNavigate()
  const dispatch = useDispatch<any>()
  const { enqueueSnackbar } = useSnackbar()
  const [searchText, setSearchText] = useState<string | undefined>()


  const loadParticipants = async () => {
    dispatch(toggleLoading())
    const where: FilterQuery<IParticipant> | undefined = searchText ? {
      $or: [
        {
          name: { $regex: searchText, $options: 'i' }
        },
        {
          id: NumberUtils.onlyNumbers(searchText)
        }]
    } : undefined

    const response = await dispatch(participantsStateLoadFromApi({
      where,
      onFinally: () => {
        dispatch(toggleLoading())

        if (tableComponentSetCurrPage)
          tableComponentSetCurrPage({
            page: 0
          })
      },
      onError: (msg) => {
        enqueueSnackbar(ApiClientUtils.getErrorMessage(msg), { variant: 'error' })
      }
    }))

    if (!response.payload?.data?.payload?.length) {
      enqueueSnackbar(ApiClientUtils.getErrorMessage('Nenhum registro encontrado'), { variant: 'warning' })
    }
  }

  return <>
    <div
      {...props}

      style={{
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        paddingBottom: DEFAULTGAP,
        ...props.style,
      }}
    >
      <HeaderComponent
        props={{
          style: {
            paddingInline: DEFAULTGAP
          }
        }}
        title='Participantes'
        onRefreshClick={loadParticipants}
        onAddClick={() => navigate(RoutesNames.participant)}
      />

      <SearchInputComponent
        style={{
          marginInline: DEFAULTGAP,
          maxWidth: 500
        }}
        label='Pesquisar por código ou nome'
        onChange={e => setSearchText(e.target.value)}
        onKeyUp={e => { if (e.key === "Enter") loadParticipants() }}
        onIconClick={loadParticipants}
      />

      <TableComponent
        wrapperProps={{ style: { padding: DEFAULTGAP, maxWidth: 'calc(100% - 10px)' } }}
        setCurrPageRef={tableComponentSetCurrPageRef}
        bodyList={participants}
        bodyRowBuilder={(participant: IParticipant) => <>
          <StyledTableCell style={{ display: 'flex', alignItems: 'center', gap: DEFAULTGAP }}>
            <ParticipantImgComponent id={participant.id} />
            <StyledListItemText
              primary={participant.name}
              secondary={participant.id}
            />
          </StyledTableCell>
        </>}
        rowProps={{
          onClickGetItem: (event: React.MouseEvent<HTMLTableRowElement, MouseEvent>, item: IParticipant) => {
            navigate(RoutesNames.participant.replace(':id', item?.id.toString()))
          }
        }}
      />
    </div>
  </>
}